import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useDeleteInfluencerV2(briefId: string) {
  const {
    mutate: deleteInfluencer,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    error: deleteInfluencerError,
  } = useMutation({
    mutationFn: (briefInfluencerIds: string[]) =>
      BriefService.deleteInfluencerV2(briefInfluencerIds).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        refetchType: "all", // Refetch all matching queries including inactive pages
      });
    },
  });

  return {
    deleteInfluencer,
    isDeleting,
    isDeleted,
    deleteInfluencerError,
  };
}
